export default "__VITE_ASSET__CM3mCg1Q__"